import React from 'react';
import {BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {getSummary} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {TransferDestinationAmounts} from './TransferDestinationAmounts';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';

interface TransferDestinationSubplanProps {
  subPlan: BuilderPot_dentistChildren;
  isSelected: boolean;
  disabled?: boolean;
  handleChange: () => void;
}

export const TransferDestinationSubplan: React.FC<TransferDestinationSubplanProps> = ({
  subPlan,
  isSelected,
  disabled,
  handleChange,
}) => {
  const {values} = useAutoForm<builderFieldsType>();
  const formikKeyPrefix = 'transfer.destinationValues';

  return (
    <PlanRow
      id={subPlan.id}
      reccId={subPlan.originalOvrId ?? null}
      isSelected={isSelected}
      isSubplan
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent={false}
        flat
        compact
        validationLevel="nothing"
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={subPlan.id}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            {getSummary(subPlan)}
          </>
        }
        summaryTrailing={
          isSelected ? (
            <PlanValidationIcon formikKeyPrefix={formikKeyPrefix} />
          ) : undefined
        }
      >
        {isSelected && (
          <TransferDestinationAmounts
            pot={subPlan}
            disabled={disabled ?? false}
            mainPlanType={values.mainPlanType}
          />
        )}
      </PlanAccordionShell>
    </PlanRow>
  );
};
